export enum VehicleGeofenceType {
  VIRTUAL = '1001',
  PHYSICS = '1002'
}